(function() {
var OmsCourseVideoPlayer,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

OmsCourseVideoPlayer = (function() {
  function OmsCourseVideoPlayer() {
    this.print_state = bind(this.print_state, this);
    this.server_url = bind(this.server_url, this);
    this.save_lesson_progress_to_server = bind(this.save_lesson_progress_to_server, this);
    this.save_lesson_completed_to_server = bind(this.save_lesson_completed_to_server, this);
    this.video_completed = bind(this.video_completed, this);
    this.update_progress = bind(this.update_progress, this);
    this.video_duration_changed = bind(this.video_duration_changed, this);
    this.setup_video_listeners = bind(this.setup_video_listeners, this);
    console.log("OmsCourseVideoPlayer: new");
    this.video_elem = $("[data-course-lesson-video]");
    this.video_node = this.video_elem.get(0);
    this.lesson_state = this.video_elem.data("course-lesson-video");
    this.have_video_duration = false;
    this.playing = false;
    this.max_time = 0;
    this.last_progress_submit_timestamp = Date.now();
    this.save_progress_interval = 5000;
    this.lesson_state.video_percent_complete = parseFloat(this.lesson_state.video_percent_complete);
    this.lesson_state.duration = 0;
    if (this.video_node == null) {
      return;
    }
    if (this.video_node.readyState >= 3) {
      this.video_duration_changed();
    }
    this.setup_video_listeners();
  }

  OmsCourseVideoPlayer.prototype.setup_video_listeners = function() {
    this.video_node.addEventListener('durationchange', (function(_this) {
      return function(e) {};
    })(this));
    this.video_node.addEventListener('loadeddata', (function(_this) {
      return function(e) {
        _this.video_duration_changed();
        return true;
      };
    })(this));
    this.video_node.addEventListener('play', (function(_this) {
      return function(e) {
        if (!_this.have_video_duration) {
          _this.video_duration_changed();
        }
        console.log("video playing");
        _this.playing = true;
        return true;
      };
    })(this));
    this.video_node.addEventListener('timeupdate', (function(_this) {
      return function(e) {
        var _new_max_time, _video_time;
        _video_time = _this.video_node.currentTime;
        if (_this.playing) {
          if (_video_time > (_this.max_time + 0.5)) {
            _this.video_node.currentTime = _this.max_time;
          } else {
            _new_max_time = Math.max(_this.max_time, _video_time);
            _this.max_time = _new_max_time;
          }
          _this.update_progress();
        }
        return true;
      };
    })(this));
    this.video_node.addEventListener('seeking', (function(_this) {
      return function(e) {
        _this.playing = false;
        return true;
      };
    })(this));
    this.video_node.addEventListener('seeked', (function(_this) {
      return function(e) {
        if (_this.video_node.currentTime > (_this.max_time + 0.5)) {
          _this.video_node.currentTime = _this.max_time;
        }
        _this.playing = true;
        return true;
      };
    })(this));
    this.video_node.addEventListener('ended', (function(_this) {
      return function(e) {
        _this.video_completed();
        return true;
      };
    })(this));
    return this.video_node.addEventListener('pause', (function(_this) {
      return function(e) {
        _this.playing = false;
        return true;
      };
    })(this));
  };

  OmsCourseVideoPlayer.prototype.video_duration_changed = function() {
    var _duration, _percent_complete;
    this.have_video_duration = true;
    _duration = this.video_node.duration;
    this.lesson_state.duration = _duration;
    _percent_complete = (this.lesson_state.video_percent_complete || 0) / 100.0;
    this.max_time = 0;
    if (_duration > 0) {
      if (this.lesson_state.video_completed || this.lesson_state.completed) {
        this.max_time = _duration;
        this.video_node.currentTime = 0;
      } else {
        this.max_time = _percent_complete * _duration;
        if (_percent_complete < 98) {
          this.video_node.currentTime = this.max_time;
        }
      }
    }
    return true;
  };

  OmsCourseVideoPlayer.prototype.update_progress = function() {
    var _time_diff, _time_now;
    this.lesson_state.video_percent_complete = this.lesson_state.duration > 0 ? ((this.max_time / this.lesson_state.duration) * 100).toFixed(2) : 0;
    _time_now = Date.now();
    _time_diff = _time_now - this.last_progress_submit_timestamp;
    if (_time_diff > this.save_progress_interval) {
      this.last_progress_submit_timestamp = _time_now;
      return this.save_lesson_progress_to_server();
    }
  };

  OmsCourseVideoPlayer.prototype.video_completed = function() {
    if (!this.lesson_state.video_completed) {
      this.lesson_state.video_completed = true;
      return this.save_lesson_completed_to_server();
    }
  };

  OmsCourseVideoPlayer.prototype.save_lesson_completed_to_server = function() {
    return $.ajax(this.server_url(), {
      type: "POST",
      data: {
        _method: "PUT",
        video_completed: true
      }
    });
  };

  OmsCourseVideoPlayer.prototype.save_lesson_progress_to_server = function() {
    return $.ajax(this.server_url(), {
      type: "POST",
      data: {
        _method: "PUT",
        video_progress: this.lesson_state.video_percent_complete
      }
    });
  };

  OmsCourseVideoPlayer.prototype.server_url = function() {
    return "/profile/courses/" + this.lesson_state.course_enrollment_id + "/lessons/" + this.lesson_state.id;
  };

  OmsCourseVideoPlayer.prototype.print_state = function() {
    console.log("----- state -----");
    console.log("course_enrollment_id: " + this.lesson_state.course_enrollment_id);
    console.log("lesson_state_id: " + this.lesson_state.id);
    console.log("lesson completed: " + this.lesson_state.completed);
    return console.log("percent_complete: " + this.lesson_state.video_percent_complete);
  };

  return OmsCourseVideoPlayer;

})();

window.alpha_oms.oms_course_video_player_constructor = OmsCourseVideoPlayer;

jQuery(function() {
  if ($("[data-course-lesson-video]").length > 0) {
    return window.alpha_oms.oms_course_video_player = new window.alpha_oms.oms_course_video_player_constructor();
  }
});

}).call(window);
